import { SVGProps } from 'react';

const Caravan = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 19H4a2 2 0 0 1-2-2V9a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2m4 6a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m12-2v1a1 1 0 0 1-1 1H10m0 0v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9"
    />
  </svg>
);
export default Caravan;
